module.exports = __webpack_public_path__ + "img/P40.0544b960.png";